"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WindowItemPostBaseline_1 = require("../model/WindowItemPostBaseline");

var WindowItemPostBaselineConverter_1 = require("./WindowItemPostBaselineConverter");
/**
 * Default implementation of WindowItemBaselineConverter.
 *
 * @author Stepan Mik
 */


var WindowItemPostBaselineConverterImpl =
/*#__PURE__*/
function (_WindowItemPostBaseli) {
  _inherits(WindowItemPostBaselineConverterImpl, _WindowItemPostBaseli);

  function WindowItemPostBaselineConverterImpl() {
    _classCallCheck(this, WindowItemPostBaselineConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemPostBaselineConverterImpl).apply(this, arguments));
  }

  _createClass(WindowItemPostBaselineConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new WindowItemPostBaseline_1.WindowItemPostBaseline(conversions.documentToClassId(source), WindowItemPostBaseline_1.WindowItemPostBaseline.schema.windowItemId.valueOf(conversions.toClassReferenceId(source.windowItemId)), WindowItemPostBaseline_1.WindowItemPostBaseline.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), WindowItemPostBaseline_1.WindowItemPostBaseline.schema.date.valueOf(conversions.toDate(source.date)), WindowItemPostBaseline_1.WindowItemPostBaseline.schema.amount.valueOf(conversions.toBigNumber(source.amount)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        windowId: conversions.toDocumentReferenceId(source.windowId),
        date: conversions.fromDate(source.date),
        amount: conversions.fromBigNumber(source.amount)
      });
      return result;
    }
  }]);

  return WindowItemPostBaselineConverterImpl;
}(WindowItemPostBaselineConverter_1.WindowItemPostBaselineConverter);

exports.WindowItemPostBaselineConverterImpl = WindowItemPostBaselineConverterImpl;